import { Box } from "@mui/material";
import { isNil, max, min } from "lodash";
import { useState } from "react";
import GossipStone from "../../core/assets/oot/gshd/gossip-stone_32x32.png"

interface DungeonSelectorProps{
    additionalOnCheck?: (index: number) => void
    value?: number
}

export const dungeons = ["", "Deku", "DC", "Jabu","Forest", "Fire", "Water", "Shadow", "Spirit", "GTG", "BotW", "Ice"]

const DungeonSelector = (props: DungeonSelectorProps) => {

   

    let [index, setIndex]= useState(props.value ?? 0)

    

    return <Box width={70} display={"flex"} textAlign={"center"} justifyContent={"center"} alignItems={"center"} onWheelCapture={(e: React.WheelEvent<HTMLDivElement>) => {
        e.preventDefault();
        let newIndex = 0;
        if (e.deltaY > 0 && index === 0) newIndex = dungeons.length-1;
        else if (e.deltaY > 0) newIndex = max([0, index - 1]) ?? 0;
        else if (e.deltaY > 0 && index === dungeons.length-1) {
            newIndex = 0;
        } else if (e.deltaY < 0 && index === dungeons.length-1) newIndex = 0;
        else if (e.deltaY < 0) newIndex = min([dungeons.length-1, index + 1]) ?? 0;
        else newIndex = dungeons.length-1;

        if (!isNil(props.additionalOnCheck)) 
            props.additionalOnCheck(newIndex);
        setIndex(newIndex);
      }}>

        {dungeons[index]}
        {index === 0 && <img src={GossipStone} alt="" width={32} height={32}/>}
    </Box>
}

export default DungeonSelector